/**
 * Tiny pub-sub for triggering the Elm chatbot from anywhere in the
 * app. The chatbot subscribes on mount and opens itself with the
 * supplied prompt when emit() fires.
 *
 * Usage:
 *   import { askElm } from "./elmChatBus";
 *   askElm("Help me write a bathroom renovation scope of work");
 */
type Listener = (prompt: string) => void;

const listeners = new Set<Listener>();

export function askElm(prompt: string): void {
  listeners.forEach((l) => l(prompt));
}

export function subscribeAskElm(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
